import React from 'react';
import $ from 'jquery';

export default class downArrow extends React.Component {

	// constructor(props) {
	//     super(props);
	//     this.scrollDown= this.scrollDown.bind(this);
	// }

	scrollDown = function(){
		var elementId = "#" + this.props.elementId;
		console.log(elementId);
		console.log($(elementId +":first").offset().top,$(elementId +":first").scrollHeight)
		$(elementId +":first").offset().top + $(elementId)[0].scrollHeight - 75
		$('body').stop().animate({
		  scrollTop: $(elementId +":first").offset().top + $(elementId)[0].scrollHeight - 78
		}, 800);
	}


	render(){
		return (
			<a className="down_arrow_wrap" onTouchTap={this.scrollDown.bind(this)} >
				<div className="ca3_fade_move_down down_arrow"></div>
		    </a>
		);
	}

}



// WEBPACK FOOTER //
// ./src/js/components/downArrow.js